import __ from 'lodash';
import axios from 'axios';
import { backendURL } from '../App';
import { useQuery } from 'react-query';

export const getReportHTMLData = async (_, type, id, streamID) => {
  // Индивидуальный отчёт участника открывается по anketaAnswersID без addo_id/key,
  // поэтому берётся синхронно из reports/data/ (по type+id), а не из reports/html/,
  // который отдаёт данные только по ключу уже сгенерированного Addo ("Wrong key" иначе).
  const { data } = await axios({
    method: 'get',
    url: `${backendURL}reports/data/`,
    params: {
      type,
      id,
      streams: true,
      stream_id: __.isNil(streamID) ? '' : streamID,
    },
  });
  return data;
};

export default function useReportHTMLData(type, id, streamID) {
  return useQuery(['reportHTMLData', type, id, streamID], getReportHTMLData, { retry: false });
}
